<div
  [ngClass]="{
    'idp-form-grouped--error': (errorState || error) && submitAttempt,
    'idp-form-grouped--absolute': isAbsolute
  }"
  [id]="id + '_parent'"
  class="idp-form-grouped"
>
  <idp-action-label
    (clicked)="notify('top')"
    (iconClicked)="iconClicked()"
    *ngIf="topLabelText"
    [class.idp-dropdown__label--absolute]="isAbsolute"
    [classList]="classListTopLabel"
    [displayFlex]="displayFlex"
    [emphasis]="hasValue ? 'dark' : ''"
    [errorState]="errorState || false"
    [helpIcon]="helpIcon"
    [helpModal]="helpModal"
    [icon]="topLabelIcon"
    [labelId]="'top_' + id"
    [name]="name"
    [ngClass]="open || focused ? 'idp-dropdown__moveTop' : ''"
    [role]="open || focused ? 'selected' : 'action'"
    [text]="topLabelText"
    [topLabelSrOnly]="topLabelSrOnly"
    [transformCapitalize]="transformCapitalize"
    class="idp-dropdown__label idp-dropdown__label--top"
  ></idp-action-label>
  <span
    *ngIf="dropdownWrapperFocused && (errorState || error)"
    aria-atomic="true"
    class="sr-only"
    data-test-error-message-screen-reader="true"
    role="alert"
    [attr.data-cy]="'error-message-screen-reader'"
  >
    {{ errorMessage }}
  </span>
  <div
    #focusElement
    (focusin)="dropdownWrapperChangeFocused(true)"
    (focusout)="dropdownWrapperChangeFocused(false); checkFocused()"
    (keydown)="tabSelection($event)"
    (keydown.arrowDown)="updateSelection($event, 'down')"
    (keydown.arrowUp)="updateSelection($event, 'up')"
    (keydown.enter)="toggle($event); refocus($event)"
    (keydown.esc)="close(); refocus($event)"
    (keypress)="updateSelection($event, 'characters')"
    (mousedown)="toggle($event); refocus($event)"
    [(setFocus)]="setDropdownWrapperFocused"
    [attr.aria-describedby]="'idp-' + id + '__selected'"
    [attr.aria-label]="
      'label_top_' + id + ' label_btm_' + id + ' label_readonly_' + id
    "
    [attr.aria-expanded]="open ? 'true' : 'false'"
    [attr.aria-labelledby]="
      'label_top_' + id + ' label_btm_' + id + ' label_readonly_' + id
    "
    [class.idp-dropdown--disabled]="disabled"
    [class.idp-dropdown__add-margin]="addMargin"
    [class.tlMaskInfo]="addtlMaskInfo"
    [id]="id + '_dropdown'"
    [ngClass]="{
      'idp-dropdown--error': errorState || error,
      'idp-dropdown__disabled': disabled
    }"
    class="idp-dropdown"
    data-test-dropdown
    [allowFocusChange]="!disabled"
    idpSetFocus
    role="combobox"
    [tabindex]="disabled ? -1 : 0"
  >
    <span *ngIf="disabled" class="sr-only" id="label_readonly_{{ id }}">
      read only
    </span>
    <div aria-hidden="true" aria-live="off">
      <idp-error-tooltip
        *ngIf="dropdownWrapperFocused && (errorState || error)"
        [arrowPosition]="arrowPosition"
        [errorMessage]="errorMessage"
        [formCtrlId]="id"
        [icon]="true"
        [attr.data-cy]="'error-tooltip'"
      ></idp-error-tooltip>
    </div>
    <div
      [(setFocus)]="dropdownSelectedFocused"
      [attr.data-selected-value]="selectedItem?.value"
      [id]="'idp-' + id + '__selected'"
      [ngClass]="open || focused ? 'idp-dropdown__focused-selected' : ''"
      class="idp-dropdown__selected"
      idpSetFocus
    >
      <span *ngIf="selectedItem && selectedItem.additionalIcon">
        <img
          class="mr-2 additionalIcon"
          src="{{ selectedItem?.additionalIcon }}"
          [attr.data-cy]="'additional-icon'"
        />
      </span>
      <span
        class="sr-only"
        [innerHTML]="setScreenReaderText()"
        [attr.data-cy]="'screen-reader-text'"
      ></span>
      <span
        aria-hidden="true"
        role="textbox"
        [innerHTML]="
          selectedItem && selectedItem?.label
            ? selectedItem?.label
            : placeholderText
        "
        [attr.data-cy]="'selected-item-label'"
      ></span>
      <span *ngIf="selectedItem && selectedItem.secondaryIcon">
        <img
          class="mr-2 logoSmall"
          src="{{ selectedItem?.secondaryIcon }}"
          [attr.data-cy]="'secondary-icon'"
        />
      </span>
      <span
        aria-hidden="true"
        role="textbox"
        [innerHTML]="
          selectedItem && selectedItem?.displayName
            ? selectedItem?.displayName
            : ''
        "
        [attr.data-cy]="'selected-item-display-name'"
      ></span>
    </div>
    <svg
      aria-hidden="true"
      [class.idp-dropdown__arrow--disabled]="disabled"
      [ngClass]="open ? 'idp-dropdown__expanded' : ''"
      class="idp-dropdown__arrow"
      disabled="disabled"
      fill-rule="evenodd"
      height="14"
      tabindex="-1"
      viewBox="0 0 15 14"
      width="15"
    >
      <path
        d="M13.0879 4.44395L12.4107 3.7334L7.87308 8.49398L3.33553 3.7334L2.65826 4.44395L7.87116 9.91301L13.0879 4.44395Z"
        fill="#E51937"
        stroke="#E51937"
      ></path>
    </svg>
    <ul
      [attr.aria-hidden]="open ? 'false' : 'true'"
      [attr.disabled]="disabled"
      [id]="id + '-desc'"
      [ngClass]="[
        open ? 'idp-dropdown__open' : '',
        customClass ? customClass : ''
      ]"
      class="idp-dropdown__list"
      role="listbox"
      tabindex="-1"
    >
      <ng-container
        *ngFor="let item of items; let i = index; trackBy: trackById"
      >
        <li
          (focusin)="liChangeFocus(true)"
          (focusout)="liChangeFocus(false)"
          (keydown.enter)="selected($event); refocus($event)"
          (keydown.tab)="toggle($event, true)"
          (mousedown)="selected($event); refocus($event)"
          [attr.aria-selected]="i === selectedItemIndex ? 'true' : 'false'"
          [attr.data-label]="item?.label"
          [attr.data-value]="item?.value"
          [attr.data]="i"
          [id]="id + 'option-' + (i + 1)"
          [ngClass]="i === selectedItemIndex ? 'idp-dropdown__list-active' : ''"
          class="idp-dropdown__list-item"
          role="option"
          tabindex="-1"
        >
          <span *ngIf="item && item.icon"><img src="{{ item?.icon }}" /></span>
          <span
            [innerHTML]="item?.label"
            [attr.aria-selected]="i === selectedItemIndex ? 'true' : 'false'"
            [attr.data-label]="item?.label"
            [attr.data-value]="item?.value"
            [attr.data]="i"
            [ngClass]="
              i === selectedItemIndex ? 'idp-dropdown__list-active' : ''
            "
          ></span>
          <span *ngIf="item && item.secondaryIcon">
            <img class="mr-2 logoSmall" src="{{ item?.secondaryIcon }}" />
          </span>
          <span
            aria-hidden="true"
            role="textbox"
            [innerHTML]="item && item?.displayName ? item?.displayName : ''"
            [attr.data-label]="item?.label"
            [attr.data-value]="item?.value"
          ></span>
        </li>
      </ng-container>
    </ul>
  </div>

  <idp-action-label
    (clicked)="notify('bottom')"
    (iconClicked)="iconClicked()"
    *ngIf="bottomLabelText"
    [class.idp-dropdown__label--absolute]="isAbsolute"
    [classList]="classListBottomLabel"
    [displayFlex]="displayFlex"
    [icon]="bottomLabelIcon"
    [labelId]="'btm_' + id"
    [text]="bottomLabelText"
    class="idp-dropdown__label idp-dropdown__label--bottom"
    role="action"
    size="small"
    [attr.data-cy]="'dropdown-bottom-label'"
  ></idp-action-label>
</div>
